import { isPlatformBrowser } from '@angular/common';
import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';

@Pipe({
  name: 'isImgNull'
})
export class IsImgNullPipe implements PipeTransform {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  transform(value: string): string {
    
      if (value && !value.includes('/null')) {
        return value;
      } else {
        if (isPlatformBrowser(this.platformId)) {
          return '//' + window.location.host + '/assets/no_photo.svg';
        }
      }
    
  }

}
